<template>
  <!--
          作者：tao
          时间：2020-12-11
          描述：抽奖码-奖品列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">

      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="期数"><el-input size="small" v-model="formInline.draw_date" placeholder="请输入抽期数 xxxx-xx"></el-input></el-form-item>
        <el-form-item label="用户名称"><el-input size="small" v-model="formInline.nickName" placeholder="请输入用户名称"></el-input></el-form-item>
        <el-form-item label="抽奖码名称"><el-input size="small" v-model="formInline.lottery_code" placeholder="请输入抽奖码名称"></el-input></el-form-item>
        <el-form-item label="抽奖类型">
          <el-select size="small" v-model="formInline.lottery_type" placeholder="所有分类">
            <el-option label="全部" value=""></el-option>
            <el-option label="月抽奖" value="10"></el-option>
            <el-option label="复活奖" value="20"></el-option>
            <el-option label="豪华奖" value="30"></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="参与起始时间">
           <div class="block">
             <span class="demonstration"></span>
             <el-date-picker
               size="small"
               v-model="formInline.create_time"
               type="daterange"
               value-format="yyyy-MM-dd"
               range-separator="至"
               start-placeholder="开始日期"
               end-placeholder="结束日期"
             ></el-date-picker>
           </div>
         </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button size="small" type="success" @click="onexel">导出</el-button>
        </el-form-item>
      </el-form>
    </div>


    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="draw_date" label="期数"></el-table-column>
          <el-table-column prop="nickName" label="用户信息">
            <template slot-scope="scope" v-if="scope.row.user != null">
              <span>{{scope.row.user.nickName}}</span>
              <span>(ID:{{scope.row.user.user_id}})</span>
            </template>

          </el-table-column>
          <el-table-column prop="lottery_code" label="抽奖码"></el-table-column>
          <el-table-column prop="is_lottery" label="是否中奖" width="80">
            <template slot-scope="scope">

              <span v-if="scope.row.is_lottery == 10">否</span>
              <span v-if="scope.row.is_lottery == 20" class="green">是</span>
            </template>
          </el-table-column>
          <el-table-column prop="lottery_type_name" label="中奖类型" width="80">

          </el-table-column>


          <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>

        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>



  </div>
</template>

<script>
import LotteryApi from '@/api/lottery.js';
import qs from 'qs';
export default {
  components: {
    /*编辑组件*/

  },
  data() {
    return {

      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        draw_date:'',
        create_time:'',
        lottery_code:"",
        nickName:"",
        lottery_type:''
      },
      is_exel:0,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      /*等级*/
      gradeList: []
    };
  },
  created() {
    /*获取列表*/

    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList(is_exel=0) {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      if(is_exel){
         Params.is_exel =1;
      }else{
        Params.is_exel =0;
      }
      LotteryApi.getDrawUserData(Params, true)
        .then(data => {
          console.log(data)
          self.loading = false;
          self.tableData = data.data.detail.data;
          self.totalDataNumber = data.data.detail.total;

        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      self.getTableList();
    },
    /*导出*/
    onexel() {

      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/plus.lottery.draw/exportLotteryUsers?' + qs.stringify(this.formInline);

    },
    /*打开添加*/
    addClick() {

      this.$router.push('/plus/lottery/prize/add');
    },

    /*取消*/
    cancelFunc() {
      /*存储缓存*/
      localStorage.setItem('activeName','draw')
      this.$router.push({
        path: '/plus/lottery/index',
        query: {
          active: 'draw',

        }
      });

    },

    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: '/plus/lottery/prize/edit',
        query: {
          lottery_prize_id: row.lottery_prize_id,
          scene: 'edit'
        }
      });
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          LotteryApi.deletePrice(
            {
              lottery_prize_id: row.lottery_prize_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，删除成功',
                  type: 'success'
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }
  }
};
</script>
<style>
  .pic{width: 80;height: 80;}
</style>



// WEBPACK FOOTER //
// src/views/plus/lottery/user/index.vue